
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}


// mp035 load jstree after bootstrap (jQuery) has loaded
require ("jstree");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

/*
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
*/



/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

window.csrf_token = document.head.querySelector('meta[name="csrf-token"]').content;
/*
if (window.csrf_token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrf_token;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
*/

/*
import ky from 'ky';

// mp035 replace axios with ky
window.axios = {};
['get','post','put','delete'].forEach(val => {
    window.axios[val] = function (url, data){
        console.log("Performing " + val);
        return ky[val](url, data).json().then(function(response){
            return {data:response};
        });
    }
});
*/

//mp035 replace axios with fetch
class HTTPError extends Error {
    constructor(response, ...params) {
      // Pass remaining arguments (including vendor specific ones) to parent constructor
      super(...params);

      this.response = response;

      // Maintains proper stack trace for where our error was thrown (only available on V8)
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, HTTPError);
      }

      this.name = 'HTTPError';
    }
}

window.axios = {};
['get','post','put','delete'].forEach(val => {
    window.axios[val] = function (url, data){
        return fetch(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                //"X-Requested-With": "XMLHttpRequest",
                "X-CSRF-Token": window.csrf_token
            },
            method: val,
            credentials: "same-origin",
            body: JSON.stringify(data),
        })
        .then( async response=>{
            if (!response.ok) {
                let data=await response.json();
                response.data = data;
                console.log(response);
                throw new HTTPError(response, response.statusText);
            }
            return response;
        }).then(async response=>{
            let data = await response.json();
            if (data.csrf_token){
                window.csrf_token = data.csrf_token;
            }
            response.data = data;
            return response;
        });
    }
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
